// extracted by mini-css-extract-plugin
module.exports = {"confirmationNumber":"thank_panel_confirmationNumber__20-Wg","container":"thank_panel_container__3SnU3","panel":"thank_panel_panel__34NSF"};